import { css } from 'lit';

import { disabled, transition, typography, on, px } from '../../styles';
import color from '../../utils/get-color-token';
import token from '../../utils/get-token';

function styles() {
	return css`
		:host {
			--m-text-field-background-color: transparent;
			--m-text-field-border-color: ${color('color-border')};
			--m-text-field-height: ${token('global-height-default')};
			--m-text-field-outline-color: ${color('color-primary-100')};
			--m-text-field-outline-offset: 2px;
			--m-text-field-padding-y: ${token('spacing-2')};
			--m-text-field-placeholder-color: ${color('color-text-placeholder')};
			--m-text-field-color: ${color('color-text-primary')};
		}

		.container {
			${typography('body-md')};
			${transition([
				{ property: 'background-color' },
				{ property: 'border-color' },
			])};

			display: inline-flex;
			align-items: center;
			justify-content: start;
			gap: ${token('spacing-2')};

			position: relative;
			box-sizing: border-box;
			width: 100%;
			block-size: var(--m-text-field-height);

			${px(token('spacing-2'))};

			background-color: var(--m-text-field-background-color);
			border-radius: ${token('border-radius-s')};
			border: 1px solid var(--m-text-field-border-color);
		}

		.container.-size-small {
			--m-text-field-height: ${token('global-height-small')};
			--m-text-field-padding-y: 0;
		}

		.container.-size-small,
		.container.-size-small .text-field {
			${typography('body-sm')};
		}

		.container.-size-large {
			--m-text-field-height: ${token('global-height-large')};
			--m-text-field-padding-y: ${token('spacing-3')};
		}

		.container.-status-danger {
			--m-text-field-border-color: ${color('color-danger-60')};
		}

		${disabled('.container')} {
			--m-text-field-background-color: ${color('color-background-tertiary')};

			cursor: default;
		}

		${disabled('.container', '*')} {
			pointer-events: none;
		}

		slot[name='leading']::slotted(*),
		slot[name='trailing']::slotted(*) {
			display: inline-flex;
			flex: 0 0 auto;
			align-items: center;
			cursor: default;
		}

		${on.hover('.container')} {
			--m-text-field-border-color: ${color('color-primary-60')};
		}

		${on.focus('.container')} {
			--m-text-field-border-color: ${color('color-primary-60')};

			outline: 1px solid var(--m-text-field-outline-color);
			outline-offset: var(--m-text-field-outline-offset);
		}

		.text-field {
			${typography('body-md')};

			border: none;
			outline: none;
			flex: 1;

			${px(0)};
			padding-block: var(--m-text-field-padding-y);

			background-color: var(--m-text-field-background-color);
			color: var(--m-text-field-color);
		}

		.text-field::placeholder {
			color: var(--m-text-field-placeholder-color);
		}

		${on.active('.text-field')},
		${on.focus('.text-field')} {
			-webkit-appearance: none;
			background: none;
			border: none;
			outline: none;
		}

		.clear {
			visibility: hidden;
		}

		.clear.is-visible {
			visibility: visible;
		}
	`;
}

export default styles;
